import React, { useState } from "react";
import { useMe } from "../hooks/useQueries";
import TourModal from "../components/TourModal";
import GrowthBanner from "../components/GrowthBanner";
import OmniAssist from "../components/OmniAssist";
import { AppShell } from "../components/layout/AppShell";
import { api } from "../lib/api";

export default function AppLayout({ children }) {
  const { data: user, isLoading } = useMe();
  const [tourOpen, setTourOpen] = useState(false);
  const [tourChecked, setTourChecked] = useState(false);

  // Show tour modal if user hasn't seen it
  React.useEffect(() => {
    if (!isLoading && user && !tourChecked) {
      setTourChecked(true);
      if (user.has_seen_tour === false) {
        setTourOpen(true);
      }
    }
  }, [isLoading, user, tourChecked]);

  async function dontShowAgain() {
    try {
      await api.post("/api/users/me/tour-seen");
    } catch {}
    setTourOpen(false);
  }

  function close() {
    setTourOpen(false);
  }

  return (
    <>
      <GrowthBanner />
      <TourModal open={tourOpen} onClose={close} onDontShowAgain={dontShowAgain} />
      <AppShell>{children}</AppShell>
      <OmniAssist />
    </>
  );
}
